import * as Sentry from '@sentry/react';

import { shouldCreateSpanForRequest } from './ignoredRequests';
import { ignoredErrors, ignoredSpanFilters } from './sentryFilters';
import { createTracesSampler } from './tracesSampler';

export function initSentry(): void {
  const sentryDsn = import.meta.env.VITE_SENTRY_DSN;

  if (!USE_SENTRY || !sentryDsn) {
    return;
  }

  Sentry.init({
    dsn: sentryDsn,
    release: VERSION,
    environment: ENVIRONMENT,
    integrations: [
      Sentry.browserTracingIntegration({ shouldCreateSpanForRequest }),
      Sentry.captureConsoleIntegration({ levels: ['error'] }),
      Sentry.replayIntegration(),
    ],
    /*
     * tracesSampleRate is set to 0 because we're using tracesSampler instead.
     * When tracesSampler is defined, it fully overrides tracesSampleRate.
     * This makes sampling logic centralized and more flexible.
     */
    tracesSampleRate: 0.0,
    tracesSampler: createTracesSampler(ENVIRONMENT),

    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [/^https:\/\/pluto3-devel\.itrack\.hu/, /^https:\/\/pluto3-devel\.itrack\.hu\/api/],

    /*
     * Session Replay records the user's interaction with the app (DOM, clicks, inputs, etc.).
     * We're not using Sentry Replay because session insights are monitored through Clarity.
     * Disabled (0.0) to reduce network traffic and avoid unnecessary event volume.
     */
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 0.0,

    ignoreErrors: ignoredErrors,
    ignoreSpans: Object.values(ignoredSpanFilters),
  });
}
